var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simplify__nav"},[_c('section',{staticClass:"stickyPanel"},[_vm._t("buttons")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }